<template>
  <header class="header" :class="[headerBgClass, { 'header-scrolled': isScrolled, 'mobile-menu-open': mobileMenuOpen }]">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <h1>{{ $t('header.logo') }}</h1>
          </router-link>
        </div>
        
        <!-- Desktop Navigation -->
        <nav class="nav desktop-nav">
          <ul class="nav-list">
            <li class="has-dropdown" :class="{ 'dropdown-active': activeDropdown === 'about' }" @mouseenter="activeDropdown = 'about'" @mouseleave="activeDropdown = null">
              <button
                class="dropdown-toggle"
                :aria-expanded="activeDropdown === 'about'"
                :aria-haspopup="true"
                aria-controls="about-dropdown"
              >
                {{ $t('header.nav.about') }}
                <span v-html="dropdownArrow"></span>
              </button>
              <div
                id="about-dropdown"
                class="dropdown"
                role="menu"
                aria-labelledby="about-dropdown"
              >
                <router-link
                  role="menuitem"
                  to="/about/overview"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.aboutOverview') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/about/hangzhou"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.aboutHangzhou') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/about/shanghai"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.aboutShanghai') }}
                </router-link>
<!--                <router-link to="/about/wuhan" @click="closeAllDropdowns">{{ $t('header.nav.aboutWuhan') }}</router-link>-->
              </div>
            </li>
            <li class="has-dropdown" :class="{ 'dropdown-active': activeDropdown === 'services' }" @mouseenter="activeDropdown = 'services'" @mouseleave="activeDropdown = null">
              <button
                class="dropdown-toggle"
                :aria-expanded="activeDropdown === 'services'"
                :aria-haspopup="true"
                aria-controls="services-dropdown"
              >
                {{ $t('header.nav.services') }}
                <span v-html="dropdownArrow"></span>
              </button>
              <div
                id="services-dropdown"
                class="dropdown"
                role="menu"
                aria-labelledby="services-dropdown"
              >
                <router-link
                  role="menuitem"
                  to="/services/expert"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.servicesExpert') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/services/data"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.servicesData') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/services/roadshow"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.servicesRoadshow') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/services/sitevisit"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.servicesSiteVisit') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/services/research"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.servicesResearch') }}
                </router-link>
              </div>
            </li>
            <li class="has-dropdown" :class="{ 'dropdown-active': activeDropdown === 'clients' }" @mouseenter="activeDropdown = 'clients'" @mouseleave="activeDropdown = null">
              <button
                class="dropdown-toggle"
                :aria-expanded="activeDropdown === 'clients'"
                :aria-haspopup="true"
                aria-controls="clients-dropdown"
              >
                {{ $t('header.nav.clients') }}
                <span v-html="dropdownArrow"></span>
              </button>
              <div
                id="clients-dropdown"
                class="dropdown"
                role="menu"
                aria-labelledby="clients-dropdown"
              >
                <router-link
                  role="menuitem"
                  to="/clients/enterprise"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.clientsEnterprise') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/clients/professional"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.clientsProfessional') }}
                </router-link>
                <router-link
                  role="menuitem"
                  to="/clients/financial"
                  @click="closeAllDropdowns"
                >
                  {{ $t('header.nav.clientsFinancial') }}
                </router-link>
              </div>
            </li>

            <li><router-link to="/expert-introduction">{{ $t('header.nav.experts') }}</router-link></li>
            <li><a href="#" @click.prevent="goToCareer">{{ $t('header.nav.career') }}</a></li>
            <li><router-link to="/compliance-framework">{{ $t('header.nav.compliance') }}</router-link></li>
            <li><a href="#" @click.prevent="goToContact">{{ $t('header.nav.contact') }}</a></li>
          </ul>
        </nav>
        
        <div class="header-right">
          <!-- Language Switcher -->
          <div class="lang-switcher">
            <div class="lang-current glass-sm" @click.stop="showLangMenu = !showLangMenu">
              <span v-html="langIcon"></span>
              <span class="lang-text">{{ currentLocale === 'zh' ? '简体中文' : 'English' }}</span>
              <span v-html="langArrow" :class="{ 'is-open': showLangMenu }"></span>
            </div>
            <transition name="fade">
              <div v-if="showLangMenu" class="lang-menu">
                <div class="lang-option" :class="{ active: currentLocale === 'zh' }" @click="switchLang('zh')">
                  <span class="check-icon" v-if="currentLocale === 'zh'">✓</span>
                  简体中文
                </div>
                <div class="lang-option" :class="{ active: currentLocale === 'en' }" @click="switchLang('en')">
                  <span class="check-icon" v-if="currentLocale === 'en'">✓</span>
                  English
                </div>
              </div>
            </transition>
          </div>
          
          <!-- Mobile Menu Button -->
          <button class="mobile-menu-btn" @click="toggleMobileMenu" aria-label="Toggle menu">
            <span class="hamburger-line" :class="{ 'open': mobileMenuOpen }"></span>
            <span class="hamburger-line" :class="{ 'open': mobileMenuOpen }"></span>
            <span class="hamburger-line" :class="{ 'open': mobileMenuOpen }"></span>
          </button>
        </div>
      </div>
    </div>
    
    <!-- Mobile Navigation -->
    <transition name="slide-down">
      <nav v-if="mobileMenuOpen" class="mobile-nav glass-sm">
        <div class="mobile-nav-content">
          <ul class="mobile-nav-list">
            <li class="mobile-has-submenu">
              <div class="mobile-nav-item" @click="toggleSubmenu('about')">
                <span>{{ $t('header.nav.about') }}</span>
                <span v-html="dropdownArrowLg" :class="{ 'open': openSubmenu === 'about' }"></span>
              </div>
              <ul v-show="openSubmenu === 'about'" class="mobile-submenu">
                <li><router-link to="/about/overview" @click="closeMobileMenu">{{ $t('header.nav.aboutOverview') }}</router-link></li>
                <li><router-link to="/about/hangzhou" @click="closeMobileMenu">{{ $t('header.nav.aboutHangzhou') }}</router-link></li>
                <li><router-link to="/about/shanghai" @click="closeMobileMenu">{{ $t('header.nav.aboutShanghai') }}</router-link></li>
              </ul>
            </li>
            <li class="mobile-has-submenu">
              <div class="mobile-nav-item" @click="toggleSubmenu('services')">
                <span>{{ $t('header.nav.services') }}</span>
                <span v-html="dropdownArrowLg" :class="{ 'open': openSubmenu === 'services' }"></span>
              </div>
              <ul v-show="openSubmenu === 'services'" class="mobile-submenu">
                <li><router-link to="/services/expert" @click="closeMobileMenu">{{ $t('header.nav.servicesExpert') }}</router-link></li>
                <li><router-link to="/services/data" @click="closeMobileMenu">{{ $t('header.nav.servicesData') }}</router-link></li>
                <li><router-link to="/services/roadshow" @click="closeMobileMenu">{{ $t('header.nav.servicesRoadshow') }}</router-link></li>
                <li><router-link to="/services/sitevisit" @click="closeMobileMenu">{{ $t('header.nav.servicesSiteVisit') }}</router-link></li>
                <li><router-link to="/services/research" @click="closeMobileMenu">{{ $t('header.nav.servicesResearch') }}</router-link></li>
              </ul>
            </li>
            <li class="mobile-has-submenu">
              <div class="mobile-nav-item" @click="toggleSubmenu('clients')">
                <span>{{ $t('header.nav.clients') }}</span>
                <span v-html="dropdownArrowLg" :class="{ 'open': openSubmenu === 'clients' }"></span>
              </div>
              <ul v-show="openSubmenu === 'clients'" class="mobile-submenu">
                <li><router-link to="/clients/enterprise" @click="closeMobileMenu">{{ $t('header.nav.clientsEnterprise') }}</router-link></li>
                <li><router-link to="/clients/professional" @click="closeMobileMenu">{{ $t('header.nav.clientsProfessional') }}</router-link></li>
                <li><router-link to="/clients/financial" @click="closeMobileMenu">{{ $t('header.nav.clientsFinancial') }}</router-link></li>
              </ul>
            </li>

            <li><router-link to="/expert-introduction" @click="closeMobileMenu">{{ $t('header.nav.experts') }}</router-link></li>
            <li><a href="#" @click.prevent="goToCareer">{{ $t('header.nav.career') }}</a></li>
            <li><router-link to="/compliance-framework" @click="closeMobileMenu">{{ $t('header.nav.compliance') }}</router-link></li>
            <li><a href="#" @click.prevent="goToContact">{{ $t('header.nav.contact') }}</a></li>
          </ul>
        </div>
      </nav>
    </transition>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { dropdownArrow, dropdownArrowLg, langIcon, langArrow } from '@/assets/icons.js'

const { locale } = useI18n()
const route = useRoute()
const router = useRouter()
const isScrolled = ref(false)
const showLangMenu = ref(false)
const activeDropdown = ref(null)
const mobileMenuOpen = ref(false)
const openSubmenu = ref(null)

const currentLocale = computed(() => locale.value)

// 根据当前路由动态设置头部背景色 - 与页面主题色协调
const headerBgClass = computed(() => {
  const path = route.path
  if (path === '/') return 'bg-home glass'
  // About pages - blue theme
  if (path === '/about/overview') return 'bg-about glass'
  if (path === '/about/hangzhou') return 'bg-hangzhou glass'
  if (path === '/about/shanghai') return 'bg-shanghai glass'
  // Services pages - various themes
  if (path === '/services/expert') return 'bg-expert glass'
  if (path === '/services/data') return 'bg-data glass'
  if (path === '/services/roadshow') return 'bg-roadshow glass'
  if (path === '/services/sitevisit') return 'bg-sitevisit glass'
  if (path === '/services/research') return 'bg-research glass'
  // Clients pages - various themes
  if (path === '/clients/enterprise') return 'bg-enterprise glass'
  if (path === '/clients/professional') return 'bg-professional glass'
  if (path === '/clients/financial') return 'bg-financial glass'
  // Advantages pages - blue theme
  if (path === '/advantages/overview') return 'bg-about glass'
  return 'bg-default glass'
})

const switchLang = (lang) => {
  locale.value = lang
  localStorage.setItem('locale', lang)
  showLangMenu.value = false
}

const closeAllDropdowns = () => {
  activeDropdown.value = null
  showLangMenu.value = false
}

const goToContact = () => {
  closeAllDropdowns()
  closeMobileMenu()
  if (route.path !== '/') {
    // 如果不在首页，先跳转到首页
    router.push('/').then(() => {
      // 等待页面渲染完成后滚动到 contact 模块
      setTimeout(() => {
        const contactSection = document.getElementById('contact')
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    })
  } else {
    // 如果在首页，直接滚动到 contact 模块
    const contactSection = document.getElementById('contact')
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

const goToCareer = () => {
  closeAllDropdowns()
  closeMobileMenu()
  if (route.path !== '/') {
    // 如果不在首页，先跳转到首页
    router.push('/').then(() => {
      // 等待页面渲染完成后滚动到 career 模块
      setTimeout(() => {
        const careerSection = document.getElementById('career')
        if (careerSection) {
          careerSection.scrollIntoView({ behavior: 'smooth' })
        }
      }, 100)
    })
  } else {
    // 如果在首页，直接滚动到 career 模块
    const careerSection = document.getElementById('career')
    if (careerSection) {
      careerSection.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
  if (!mobileMenuOpen.value) {
    openSubmenu.value = null
  }
}

const closeMobileMenu = () => {
  mobileMenuOpen.value = false
  openSubmenu.value = null
}

const toggleSubmenu = (menu) => {
  openSubmenu.value = openSubmenu.value === menu ? null : menu
}

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50
}

const handleClickOutside = (e) => {
  const langSwitcher = document.querySelector('.lang-switcher')
  if (langSwitcher && !langSwitcher.contains(e.target)) {
    showLangMenu.value = false
  }
}

const handleResize = () => {
  if (window.innerWidth > 1024 && mobileMenuOpen.value) {
    closeMobileMenu()
  }
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
  document.addEventListener('click', handleClickOutside)
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  document.removeEventListener('click', handleClickOutside)
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
/* ========== 基础样式 ========== */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  transition: all 0.3s ease;
}

/* 滚动后统一白底样式 */
.header-scrolled {
  background: color-mix(in srgb, var(--white) 85%, transparent) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;
  box-shadow: 0 1px 0 color-mix(in srgb, var(--primary-color) 5%, transparent);
}

.header-scrolled .nav-list > li > a,
.header-scrolled .nav-list > li > .dropdown-toggle {
  color: var(--text-dark) !important;
  text-shadow: none !important;
  font-weight: 600;
}

.header-scrolled .logo h1 {
  color: var(--primary-color) !important;
  text-shadow: none !important;
}

.header-scrolled .lang-current {
  color: var(--text-dark) !important;
  background: color-mix(in srgb, var(--primary-color) 5%, transparent) !important;
}

/* ========== Header Content ========== */
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
}

@media (max-width: 1366px) {
  .header-content {
    height: 80px;
  }
}

@media (max-width: 1024px) {
  .header-content {
    height: 70px;
  }
}

@media (max-width: 768px) {
  .header-content {
    height: 60px;
  }
}

/* ========== Logo ========== */
.logo a {
  text-decoration: none;
}

.logo h1 {
  font-size: 1.6rem;
  font-weight: 700;
  transition: color 0.3s ease;
}

@media (max-width: 1366px) {
  .logo h1 {
    font-size: 1.5rem;
  }
}

@media (max-width: 1024px) {
  .logo h1 {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .logo h1 {
    font-size: 1.3rem;
  }
}

@media (max-width: 375px) {
  .logo h1 {
    font-size: 1.2rem;
  }
}

/* ========== Desktop Navigation ========== */
.nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

@media (max-width: 1024px) {
  .desktop-nav {
    display: none;
  }
}

.nav-list {
  display: flex;
  gap: 40px;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

@media (max-width: 1366px) {
  .nav-list {
    gap: 32px;
  }
}

@media (max-width: 1200px) {
  .nav-list {
    gap: 24px;
  }
}

.nav-list > li > a,
.nav-list > li > .dropdown-toggle {
  font-weight: 500;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  text-decoration: none;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  font-family: inherit;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 1366px) {
  .nav-list > li > a,
  .nav-list > li > .dropdown-toggle {
    font-size: 0.9rem;
  }
}

@media (max-width: 1200px) {
  .nav-list > li > a,
  .nav-list > li > .dropdown-toggle {
    font-size: 0.85rem;
  }
}

/* ========== Header Right ========== */
.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* ========== Language Switcher ========== */
.lang-switcher {
  position: relative;
}

.lang-current {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .lang-current {
    padding: 6px 10px;
    font-size: 0.85rem;
  }
  
  .lang-text {
    display: none;
  }
}

.lang-icon {
  opacity: 0.8;
}

.lang-text {
  font-weight: 500;
}

.lang-arrow {
  opacity: 0.6;
  transition: transform 0.3s ease;
}

.lang-arrow.is-open {
  transform: rotate(180deg);
}

.lang-menu {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 4px 20px color-mix(in srgb, var(--primary-color) 15%, transparent);
  padding: 8px 0;
  min-width: 140px;
  z-index: 1001;
}

@media (max-width: 768px) {
  .lang-menu {
    right: -20px;
    min-width: 120px;
  }
}

.lang-menu::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: var(--white);
  transform: rotate(45deg);
  border-radius: 2px;
}

@media (max-width: 768px) {
  .lang-menu::before {
    right: 28px;
  }
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--text-dark);
  transition: all 0.2s ease;
}

.lang-option:hover {
  background: var(--bg-light);
  color: var(--primary-color);
}

.lang-option.active {
  color: var(--primary-color);
  font-weight: 500;
}

.check-icon {
  font-size: 0.85rem;
  color: var(--secondary-color);
}

/* ========== Mobile Menu Button ========== */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  gap: 5px;
}

@media (max-width: 1024px) {
  .mobile-menu-btn {
    display: flex;
  }
}

.hamburger-line {
  display: block;
  width: 24px;
  height: 2px;
  background: currentColor;
  transition: all 0.3s ease;
  border-radius: 2px;
}

.hamburger-line.open:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-line.open:nth-child(2) {
  opacity: 0;
}

.hamburger-line.open:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* ========== Mobile Navigation ========== */
.mobile-nav {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-height: calc(100vh - 70px);
  overflow-y: auto;
}

@media (max-width: 1024px) {
  .mobile-nav {
    display: block;
  }
}

@media (max-width: 768px) {
  .mobile-nav {
    max-height: calc(100vh - 60px);
  }
}

.mobile-nav-content {
  padding: 16px 24px;
}

@media (max-width: 768px) {
  .mobile-nav-content {
    padding: 12px 16px;
  }
}

.mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.mobile-nav-list > li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.mobile-nav-list > li:last-child {
  border-bottom: none;
}

.mobile-nav-list > li > a,
.mobile-nav-item {
  display: block;
  padding: 16px 0;
  color: var(--text-dark);
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s ease;
}

@media (max-width: 768px) {
  .mobile-nav-list > li > a,
  .mobile-nav-item {
    padding: 14px 0;
    font-size: 0.95rem;
  }
}

.mobile-nav-list > li > a:hover,
.mobile-nav-item:hover {
  color: var(--primary-color);
}

.mobile-nav-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.submenu-arrow {
  transition: transform 0.3s ease;
}

.submenu-arrow.open {
  transform: rotate(180deg);
}

.mobile-submenu {
  list-style: none;
  margin: 0;
  padding: 0 0 8px 16px;
}

.mobile-submenu > li > a {
  display: block;
  padding: 12px 0;
  color: var(--text-light);
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.3s ease;
}

@media (max-width: 768px) {
  .mobile-submenu > li > a {
    padding: 10px 0;
    font-size: 0.85rem;
  }
}

.mobile-submenu > li > a:hover {
  color: var(--primary-color);
}

/* ========== Dropdown styles (Desktop) ========== */
.has-dropdown {
  position: relative;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  user-select: none;
}

.dropdown-toggle .arrow {
  transition: transform 0.3s ease;
  opacity: 0.7;
}

.has-dropdown.dropdown-active .dropdown-toggle .arrow {
  transform: rotate(180deg);
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: var(--white);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  min-width: 180px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 100;
  margin-top: 10px;
}

.has-dropdown.dropdown-active .dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.dropdown::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: var(--white);
  border-radius: 2px;
}

.dropdown a {
  display: block;
  padding: 10px 16px;
  color: var(--text-dark) !important;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  text-decoration: none;
}

.dropdown a:hover {
  background: var(--bg-light);
  color: var(--primary-color) !important;
  padding-left: 20px;
}

.dropdown a {
  position: relative;
  overflow: hidden;
}

.dropdown a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--secondary-color);
  transform: scaleY(0);
  transition: transform 0.2s ease;
}

.dropdown a:hover::before {
  transform: scaleY(1);
}

/* ========== Transitions ========== */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ========== 页面主题色配置 ========== */

/* 首页 - 苹果毛玻璃效果 */
.bg-home {
  background: rgba(15, 39, 64, 0.65);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bg-home .nav-list > li > a,
.bg-home .nav-list > li > .dropdown-toggle {
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  font-weight: 600;
}

.bg-home .nav-list > li > a:hover,
.bg-home .nav-list > li > .dropdown-toggle:hover {
  color: #fff;
}

.bg-home .mobile-menu-btn .hamburger-line {
  background: rgba(255, 255, 255, 0.95);
}

.bg-home.header-scrolled .mobile-menu-btn .hamburger-line {
  background: var(--text-dark);
}

.bg-home .logo h1 {
  color: #fff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.bg-home .lang-current {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.15);
}

/* About 页面 - 苹果毛玻璃效果 */
.bg-about, .bg-hangzhou, .bg-shanghai, .bg-wuhan {
  background: rgba(30, 58, 95, 0.75);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bg-about .nav-list > li > a,
.bg-about .nav-list > li > .dropdown-toggle,
.bg-hangzhou .nav-list > li > a,
.bg-hangzhou .nav-list > li > .dropdown-toggle,
.bg-shanghai .nav-list > li > a,
.bg-shanghai .nav-list > li > .dropdown-toggle,
.bg-wuhan .nav-list > li > a,
.bg-wuhan .nav-list > li > .dropdown-toggle {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.bg-about .nav-list > li > a:hover,
.bg-about .nav-list > li > .dropdown-toggle:hover,
.bg-hangzhou .nav-list > li > a:hover,
.bg-hangzhou .nav-list > li > .dropdown-toggle:hover,
.bg-shanghai .nav-list > li > a:hover,
.bg-shanghai .nav-list > li > .dropdown-toggle:hover,
.bg-wuhan .nav-list > li > a:hover,
.bg-wuhan .nav-list > li > .dropdown-toggle:hover {
  color: #fff;
}

.bg-about .mobile-menu-btn .hamburger-line,
.bg-hangzhou .mobile-menu-btn .hamburger-line,
.bg-shanghai .mobile-menu-btn .hamburger-line,
.bg-wuhan .mobile-menu-btn .hamburger-line {
  background: rgba(255, 255, 255, 0.95);
}

.bg-about.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-hangzhou.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-shanghai.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-wuhan.header-scrolled .mobile-menu-btn .hamburger-line {
  background: var(--text-dark);
}

.bg-about .logo h1,
.bg-hangzhou .logo h1,
.bg-shanghai .logo h1,
.bg-wuhan .logo h1 {
  color: #fff;
}

.bg-about .lang-current,
.bg-hangzhou .lang-current,
.bg-shanghai .lang-current,
.bg-wuhan .lang-current {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.15);
}

/* Services 页面 - 统一深蓝色主题 */
.bg-expert,
.bg-data,
.bg-roadshow,
.bg-sitevisit,
.bg-research {
  background: rgba(15, 39, 64, 0.75);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bg-expert .nav-list > li > a,
.bg-expert .nav-list > li > .dropdown-toggle,
.bg-data .nav-list > li > a,
.bg-data .nav-list > li > .dropdown-toggle,
.bg-roadshow .nav-list > li > a,
.bg-roadshow .nav-list > li > .dropdown-toggle,
.bg-sitevisit .nav-list > li > a,
.bg-sitevisit .nav-list > li > .dropdown-toggle,
.bg-research .nav-list > li > a,
.bg-research .nav-list > li > .dropdown-toggle {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.bg-expert .nav-list > li > a:hover,
.bg-expert .nav-list > li > .dropdown-toggle:hover,
.bg-data .nav-list > li > a:hover,
.bg-data .nav-list > li > .dropdown-toggle:hover,
.bg-roadshow .nav-list > li > a:hover,
.bg-roadshow .nav-list > li > .dropdown-toggle:hover,
.bg-sitevisit .nav-list > li > a:hover,
.bg-sitevisit .nav-list > li > .dropdown-toggle:hover,
.bg-research .nav-list > li > a:hover,
.bg-research .nav-list > li > .dropdown-toggle:hover {
  color: #fff;
}

.bg-expert .mobile-menu-btn .hamburger-line,
.bg-data .mobile-menu-btn .hamburger-line,
.bg-roadshow .mobile-menu-btn .hamburger-line,
.bg-sitevisit .mobile-menu-btn .hamburger-line,
.bg-research .mobile-menu-btn .hamburger-line {
  background: rgba(255, 255, 255, 0.95);
}

.bg-expert.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-data.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-roadshow.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-sitevisit.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-research.header-scrolled .mobile-menu-btn .hamburger-line {
  background: var(--text-dark);
}

.bg-expert .logo h1,
.bg-data .logo h1,
.bg-roadshow .logo h1,
.bg-sitevisit .logo h1,
.bg-research .logo h1 {
  color: #fff;
}

.bg-expert .lang-current,
.bg-data .lang-current,
.bg-roadshow .lang-current,
.bg-sitevisit .lang-current,
.bg-research .lang-current {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.15);
}

/* Clients 页面 - 统一深蓝色主题 */
.bg-enterprise,
.bg-professional,
.bg-financial {
  background: rgba(15, 39, 64, 0.75);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bg-enterprise .nav-list > li > a,
.bg-enterprise .nav-list > li > .dropdown-toggle,
.bg-professional .nav-list > li > a,
.bg-professional .nav-list > li > .dropdown-toggle,
.bg-financial .nav-list > li > a,
.bg-financial .nav-list > li > .dropdown-toggle {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.bg-enterprise .nav-list > li > a:hover,
.bg-enterprise .nav-list > li > .dropdown-toggle:hover,
.bg-professional .nav-list > li > a:hover,
.bg-professional .nav-list > li > .dropdown-toggle:hover,
.bg-financial .nav-list > li > a:hover,
.bg-financial .nav-list > li > .dropdown-toggle:hover {
  color: #fff;
}

.bg-enterprise .mobile-menu-btn .hamburger-line,
.bg-professional .mobile-menu-btn .hamburger-line,
.bg-financial .mobile-menu-btn .hamburger-line {
  background: rgba(255, 255, 255, 0.95);
}

.bg-enterprise.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-professional.header-scrolled .mobile-menu-btn .hamburger-line,
.bg-financial.header-scrolled .mobile-menu-btn .hamburger-line {
  background: var(--text-dark);
}

.bg-enterprise .logo h1,
.bg-professional .logo h1,
.bg-financial .logo h1 {
  color: #fff;
}

.bg-enterprise .lang-current,
.bg-professional .lang-current,
.bg-financial .lang-current {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.15);
}

/* 默认 - 苹果毛玻璃效果 */
.bg-default {
  background: rgba(15, 39, 64, 0.75);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.bg-default .nav-list > li > a,
.bg-default .nav-list > li > .dropdown-toggle {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

.bg-default .nav-list > li > a:hover,
.bg-default .nav-list > li > .dropdown-toggle:hover {
  color: #fff;
}

.bg-default .mobile-menu-btn .hamburger-line {
  background: rgba(255, 255, 255, 0.95);
}

.bg-default.header-scrolled .mobile-menu-btn .hamburger-line {
  background: var(--text-dark);
}

.bg-default .logo h1 {
  color: #fff;
}

.bg-default .lang-current {
  color: rgba(255, 255, 255, 0.95);
  background: rgba(255, 255, 255, 0.15);
}
</style>
